function GamingPanel() {
  return (

    <div className="full-height align-center">
      <div className="p-3 grey-3 index-card-background-top">
        <img
          src={process.env.PUBLIC_URL + "/images/home/videoGame.png"}
          className="index-card-icon"
          alt="careerIcon"
        />
        <div className="index-card-header">Gaming</div>
        <div className="left">
          I enjoy playing video and board games. I mostly play League of Legends and Runescape and my current favorite board game is Codenames.
        </div>
      </div>
      <div className="p3 grey-2 index-card-background-bottom">
        <a href="./gaming" className="index-card-see-more no-line">
          <div className="index-card-see-more no-line">SEE MORE</div>
        </a>
      </div>

    </div>
  );
}

export default GamingPanel;
